import { Source, Layer } from 'react-map-gl';
import { COLOR } from '../styles';
import { sourceProps } from './source-utils';

export function NucleosLayer({ url }: { url: string }) {
  return (
    <Source id="nucleos" {...sourceProps(url)}>
      <Layer
        id="nucleos-fill"
        type="fill"
        paint={{ 'fill-color': COLOR.teal, 'fill-opacity': 0.05 }}
      />
      <Layer
        id="nucleos-outline"
        type="line"
        paint={{ 'line-color': COLOR.teal, 'line-width': 1 }}
      />
    </Source>
  );
}
